import { useState, useEffect, useRef } from 'react'

import Breadcrumb from '../../../components/breadcrumb/index'
import DataTable_Component from '../../../components/DataTable/index'


import Swal from 'sweetalert2'

import { apidata } from './store/store'
import { Link } from 'react-router-dom'
// import {Modal} from 'bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare,faTrash,faEnvelope,faCopy} from '@fortawesome/free-solid-svg-icons'

// import toastr from 'reactjs-toastr';
// import 'reactjs-toastr/lib/toast.css';


export default function ManageBrand() {

    const title="Manage Bank"
    const [apistate, setApiState] = useState([])
    {/* data table column name */ }
    const [apicol, setApiCol] = useState([])
    const[rerendarApi,setRerendarApi]=useState(false)

    {/* data receve from store */ }
    useEffect(() => {
        // call api
        setApiState(apidata)
        setApiCol(columns)
        console.log("render from bank Transfer")
    }, [rerendarApi])

    const delete_row=(row)=>{
        console.log(row)
        Swal.fire({
            icon:'warning',
            title: 'You wont be able to revert this!',       
            showCancelButton: true,
            confirmButtonText: 'Yes',
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            setRerendarApi(!rerendarApi)
            if (result.isConfirmed) {
              Swal.fire('Saved!. id:'+row.id, '', 'success')
            } else if (result.isDenied) {
              Swal.fire('Changes are not saved', '', 'info')
            }
          })
    }
  
    const brad = [
        {
            name: "home",
        },
        {
            name: title,
        }
    ]
    const columns = [
        {
            name: "Brand",
            selector: row => row.brand,
            sortable: true
        },
        {
            name: "Bank Name",
            selector: row => row.bank_name,
            sortable: true
        },
        {
            name: "Account Name",
            selector: row => row.account_name,
            sortable: true
        },
        {
            name: "Account Number",
            selector: row => row.account_number,
            sortable: true
        },
        
        {
            name: "Branch Name",
            selector: row => row.branch_name,
            sortable: true
        },
        {
            name: "Routing number",
            selector: row => row.routing_number,
            sortable: true
        },       
        {
            name: "Status",
            cell: (row) => <><button className={`btn p-0 px-1 ${row.status.toLowerCase() == "inactive" && "btn-danger"} ${row.status.toLowerCase() == "active" ? "btn-success" : ""}   btn-sm`}  >{row.status}</button></>,

        },
        {
            name: "Action",
            cell: (row) => <><Link to={`/bankTransfer/edit-bank/${row.id}`}> <button  className="btn btn-primary btn-sm" ><FontAwesomeIcon icon={faPenToSquare} /></button></Link><button onClick={()=>delete_row(row)} className="btn btn-danger ms-1 btn-sm" ><FontAwesomeIcon icon={faPenToSquare} /></button></>,
        }

    ]

    return (
        <>
            
           
            <div className="container-fluid" >
                <Breadcrumb title={title} brad={brad} />
                
                <div className="row my-3">
                    <div className="col-12">
                        <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
                            <div className="card-header d-flex justify-content-between border-bottom pb-1">
                                <h4>{title}</h4>
                                <Link to="/bankTransfer/add-bank"><div className="btn btn-info btn-sm text-white">Add Bank</div></Link>
                            </div>
                            <div className="card-body">
                               
                                <DataTable_Component search="account_name" title_btn="Add stored Data" title={title} apidata={apistate} columns={apicol} />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}